module.exports = __webpack_public_path__ + "static/media/12-Rostock.4837c940.jpg";